import service from "./service"

const company = async () => {
    return service()
}

export default company
